// ----------------------------------------------------------------------

export default function Dialog(theme) {
  return {
    MuiDialog: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.dialog,
          '&.MuiPaper-rounded': {
            borderRadius: Number(theme.shape.borderRadius) * 2
          },
          // MUI writes the fullScreen paper styles at the same specificity as
          // this override, and earlier, so the phone margin below used to win
          // over them: a full-screen dialog kept a 16px margin and ran off the
          // screen. The two-class rule settles it.
          '&.MuiDialog-paperFullScreen': {
            margin: 0,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: 'none',
            borderRadius: 0
          },
          '&.MuiDialog-paper .MuiDialogActions-root': {
            padding: theme.spacing(3)
          },
          '@media (max-width: 600px)': {
            margin: theme.spacing(2)
          },
          '@media (max-width: 663.95px)': {
            '&.MuiDialog-paperWidthSm.MuiDialog-paperScrollBody': {
              maxWidth: '100%'
            }
          }
        },
        // A full-width dialog is as wide as the screen LESS its margins —
        // `width: 100%` made every one of them overflow by exactly the
        // margin (most visibly on a phone, where the actions ran off the
        // right edge).
        paperFullWidth: {
          width: 'calc(100% - 64px)',
          '@media (max-width: 600px)': {
            width: 'calc(100% - 32px)'
          }
        }
      }
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 0)
        }
      }
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          borderTop: 0,
          borderBottom: 0,
          padding: theme.spacing(3)
        }
      }
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          '& > :not(:first-of-type)': {
            marginLeft: theme.spacing(1.5)
          }
        }
      }
    }
  };
}
